<!-- eslint-disable max-lines -->
<template>
	<div class="cassie-vertical-md">
		<SectionCard>
			<template #title>
				Search Criteria Configuration
			</template>
			<template #body>
				<div
					v-if="userFullPermissions"
					class="d-flex cassie-horizontal-md"
				>
					<Dropdown
						v-model="selectedSearchCriteriaFields"
						:search-input.sync="searchCriteriaSearchInput"
						label="Search Criteria Fields"
						:items="availableSearchCriteriaFields"
						multiple
						searchable
						select-all
						@change="updateSearchCriteriaSelectAllChecked"
					>
						<template
							v-if="availableSearchCriteriaFields.length > 1"
							#prepend-item
						>
							<v-list-item
								dense
								@click="toggleSearchCriteriaSelectAll"
							>
								<v-checkbox
									v-model="searchCriteriaSelectAllChecked"
									dense
									@click="toggleSearchCriteriaSelectAll"
								/>
								<v-list-item-title class="pb-2">
									Select All
								</v-list-item-title>
							</v-list-item>
							<v-divider />
						</template>
					</Dropdown>
					<PrimaryActionButton
						:disabled="!selectedSearchCriteriaFields.length"
						@click="addSearchCriteriaFields"
					>
						Add
					</PrimaryActionButton>
				</div>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th
									class="text-left"
									style="width: 35%;"
									scope="col"
								>
									Database Field Name
								</th>
								<th
									class="text-left"
									style="width: 45%;"
									scope="col"
								>
									Field Label On Search Screen And Profile Grid
								</th>
								<th
									class="text-right"
									style="width: 20%;"
									scope="col"
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(searchField, index) in searchableFields"
								:key="searchField.fieldName"
							>
								<td class="text-left">
									{{ searchField.fieldName }}
								</td>
								<td class="text-left">
									<TextField
										:disabled="!userFullPermissions"
										:value="searchField.fieldLabel"
										:rules="{ max: 200 }"
										small
										label="Field label"
										@input="updateSearchFieldLabel(searchField.searchFieldId, 'fieldLabel', $event)"
									/>
								</td>
								<td class="text-right">
									{{ searchField.displayOrder > 0 ? searchField.displayOrder : null }}
									<IconButton
										v-if="searchField.displayOrder && searchField.displayOrder !== 1 && userFullPermissions"
										small
										@click="changeDisplayOrder(index, 'moveUp')"
									>
										mdi-arrow-up
									</IconButton>
									<IconButton
										v-if="searchField.displayOrder && searchField.displayOrder !== searchableFields.length && userFullPermissions"
										small
										@click="changeDisplayOrder(index, 'moveDown')"
									>
										mdi-arrow-down
									</IconButton>
									<v-menu
										v-if="userFullPermissions"
										offset-y
									>
										<template #activator="{ on, attrs }">
											<v-btn
												icon
												v-bind="attrs"
												v-on="on"
												@click.stop
											>
												<v-icon>
													mdi-dots-horizontal
												</v-icon>
											</v-btn>
										</template>
										<v-list dense>
											<v-list-item @click="deleteSearchField(searchField.searchFieldId)">
												<v-list-item-content>
													<v-list-item-title>
														Delete
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</template>
		</SectionCard>
		<SectionCard>
			<template #title>
				Search Result Configuration
			</template>
			<template #body>
				<div
					v-if="userFullPermissions"
					class="d-flex cassie-horizontal-md"
				>
					<Dropdown
						v-model="selectedSearchResultFields"
						:search-input.sync="searchResultSearchInput"
						label="Search Result Fields"
						:items="availableSearchResultFields"
						multiple
						searchable
						select-all
						@change="updateSearchResultSelectAllChecked"
					>
						<template
							v-if="availableSearchResultFields.length > 1"
							#prepend-item
						>
							<v-list-item
								dense
								@click="toggleSearchResultSelectAll"
							>
								<v-checkbox
									v-model="searchResultSelectAllChecked"
									dense
									@click="toggleSearchResultSelectAll"
								/>
								<v-list-item-title class="pb-2">
									Select All
								</v-list-item-title>
							</v-list-item>
							<v-divider />
						</template>
					</Dropdown>
					<PrimaryActionButton
						:disabled="!selectedSearchResultFields.length"
						@click="addSearchResultFields"
					>
						Add
					</PrimaryActionButton>
				</div>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th
									class="text-left"
									style="width: 35%;"
									scope="col"
								>
									Database Field Name
								</th>
								<th
									class="text-left"
									style="width: 45%;"
									scope="col"
								>
									Field Label On Search Screen And Profile Grid
								</th>
								<th
									class="text-right"
									style="width: 20%;"
									scope="col"
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(searchField, index) in searchResultsFields"
								:key="searchField.fieldName"
							>
								<td class="text-left">
									{{ searchField.fieldName }}
								</td>
								<td class="text-left">
									<TextField
										:disabled="!userFullPermissions"
										:value="searchField.fieldLabel"
										:rules="{ max: 200 }"
										small
										label="Field label"
										@input="updateSearchFieldLabel(searchField.searchFieldId, 'fieldLabel', $event)"
									/>
								</td>
								<td class="text-right">
									{{ searchField.searchResultsDisplayOrder > 0 ? searchField.searchResultsDisplayOrder : null }}
									<IconButton
										v-if="searchField.searchResultsDisplayOrder && searchField.searchResultsDisplayOrder !== 1 && userFullPermissions"
										@click="changeSearchResultsDisplayOrder(index, 'moveUp')"
									>
										mdi-arrow-up
									</IconButton>
									<IconButton
										v-if="searchField.searchResultsDisplayOrder && searchField.searchResultsDisplayOrder !== searchResultsFields.length && userFullPermissions"
										@click="changeSearchResultsDisplayOrder(index, 'moveDown')"
									>
										mdi-arrow-down
									</IconButton>
									<v-menu
										v-if="userFullPermissions"
										offset-y
									>
										<template #activator="{ on, attrs }">
											<v-btn
												icon
												v-bind="attrs"
												v-on="on"
												@click.stop
											>
												<v-icon>
													mdi-dots-horizontal
												</v-icon>
											</v-btn>
										</template>
										<v-list dense>
											<v-list-item @click="deleteSearchResultField(searchField.searchFieldId)">
												<v-list-item-content>
													<v-list-item-title>
														Delete
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</template>
		</SectionCard>
		<SectionCard>
			<template #title>
				Profile Grid Configuration
			</template>
			<template #body>
				<div
					v-if="userFullPermissions"
					class="d-flex cassie-horizontal-md"
				>
					<Dropdown
						v-model="selectedProfileGridFields"
						label="Profile Grid Fields"
						:items="availableProfileGridFields"
						multiple
					/>
					<PrimaryActionButton
						:disabled="!selectedProfileGridFields.length"
						@click="addProfileGridFields"
					>
						Add
					</PrimaryActionButton>
				</div>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th
									class="text-left"
									style="width: 50%;"
									scope="col"
								>
									Database Field Name
								</th>
								<th
									class="text-left"
									style="width: 50%;"
									scope="col"
								>
									Field Label On Search Screen And Profile Grid
								</th>
								<th
									class="text-center"
									style="width: 80px;"
									scope="col"
									align="center"
									sortable="false"
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="profileField in profileGridFields"
								:key="profileField.fieldName"
							>
								<td class="text-left">
									{{ profileField.fieldName }}
								</td>
								<td class="text-left">
									<TextField
										:disabled="!userFullPermissions"
										:value="profileField.fieldLabel"
										:rules="{ max: 200 }"
										small
										label="Field label"
										@input="updateProfileFieldLabel(profileField.searchFieldId, 'fieldLabel', $event)"
									/>
								</td>
								<td class="text-center">
									<v-menu
										v-if="userFullPermissions"
										offset-y
									>
										<template #activator="{ on, attrs }">
											<v-btn
												icon
												v-bind="attrs"
												v-on="on"
												@click.stop
											>
												<v-icon>
													mdi-dots-horizontal
												</v-icon>
											</v-btn>
										</template>
										<v-list dense>
											<v-list-item @click="deleteProfileGridField(profileField.searchFieldId)">
												<v-list-item-content>
													<v-list-item-title>
														Delete
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</template>
		</SectionCard>
	</div>
</template>

<script>
/* eslint-disable max-lines */
import SectionCard from '../../../../../shared/components/section-card.vue'
import Dropdown from '../../../../../shared/components/dropdown.vue'
import PrimaryActionButton from '../../../../../shared/components/primary-action-button.vue'
import TextField from '../../../../../shared/components/text-field.vue'
import IconButton from '../../../../../shared/components/icon-button.vue'
import { showSnackbar } from '../../../../../shared/state/snackbar.js'
import { searchFieldFilter } from '../../../../../shared/state/configuration.js'

export default {
	components: { TextField, SectionCard, IconButton, Dropdown, PrimaryActionButton },
	props: {
		configuration: {
			type: Object,
			default: () => ({})
		},
		searchFields: {
			type: Array,
			default: () => []
		},
		availableFields: {
			type: Array,
			default: () => []
		},
		userFullPermissions: {
			type: Boolean,
			default: false
		}
	},
	setup () {
		return {
			showSnackbar
		}
	},
	data () {
		return {
			selectedSearchCriteriaFields: [],
			selectedSearchResultFields: [],
			selectedProfileGridFields: [],
			searchCriteriaSearchInput: null,
			searchCriteriaSelectAllChecked: false,
			searchResultSearchInput: null,
			searchResultSelectAllChecked: false
		}
	},
	computed: {
		availableFieldItems () {
			return this.searchFields.map(({ fieldName, searchFieldId, isSearchableBy, includeInSearchResults, showInProfilesTable }) => ({
				text: this.availableFields.find(({ columnName }) => columnName.toLowerCase() === fieldName.toLowerCase())?.columnName,
				value: searchFieldId,
				isSearchableBy: isSearchableBy,
				includeInSearchResults: includeInSearchResults,
				showInProfilesTable: showInProfilesTable
			})).sort((a, b) => a.text.localeCompare(b.text))
		},
		maxSearchResultsFields () {
			return 12
		},
		maxProfileGridFields () {
			return 12
		},
		availableSearchCriteriaFields () {
			return this.availableFieldItems.filter(({ isSearchableBy, text }) => isSearchableBy === false && searchFieldFilter(text))
		},
		availableSearchResultFields () {
			return this.availableFieldItems.filter(({ includeInSearchResults }) => includeInSearchResults === false)
		},
		availableProfileGridFields () {
			return this.availableFieldItems.filter(({ showInProfilesTable }) => !showInProfilesTable)
		},
		mappedSearchFields () {
			const searchFields = this.searchFields
			return searchFields.map(searchField => ({
				...searchField,
				displayOrder: searchField.displayOrder === 0 ? null : searchField.displayOrder,
				searchResultsDisplayOrder: searchField.searchResultsDisplayOrder === 0 ? null : searchField.searchResultsDisplayOrder
			})).sort((a, b) => {
				// ensure search fields with no display order is last
				return (a.displayOrder === null) - (b.displayOrder === null) || +(a.displayOrder > b.displayOrder) || -(a.displayOrder < b.displayOrder)
			})
		},
		searchableFields () {
			const criteriaFields = this.searchFields.filter(({ isSearchableBy }) => isSearchableBy)
			return criteriaFields.sort((a, b) => {
				// ensure search fields with no display order is last
				return (a.displayOrder === null) - (b.displayOrder === null) || +(a.displayOrder > b.displayOrder) || -(a.displayOrder < b.displayOrder)
			})
		},
		searchResultsFields () {
			const resultFields = this.searchFields.filter(({ includeInSearchResults }) => includeInSearchResults)
			return resultFields.sort((a, b) => {
				// ensure search fields with no display order is last
				return (a.searchResultsDisplayOrder === null) - (b.searchResultsDisplayOrder === null) || +(a.searchResultsDisplayOrder > b.searchResultsDisplayOrder) ||
					-(a.searchResultsDisplayOrder < b.searchResultsDisplayOrder)
			})
		},
		profileGridFields () {
			const profileFields = this.searchFields.filter(({ showInProfilesTable }) => showInProfilesTable)
			return profileFields.sort((a, b) => (a.displayOrder === null) - (b.displayOrder === null) || +(a.displayOrder > b.displayOrder) || -(a.displayOrder < b.displayOrder))
		}
	},
	methods: {
		updateSearchFieldLabel (fieldId, property, value) {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const matchingField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			matchingField[property] = value
			this.updateSearchFields(searchFields)
		},
		updateProfileFieldLabel (fieldId, property, value) {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const matchingField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			matchingField[property] = value
			this.updateSearchFields(searchFields)
		},
		changeDisplayOrder (index, direction) {
			const fieldId = this.searchableFields[index].searchFieldId
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const moveUp = 'moveUp'
			const selectedSearchField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			const previousSearchField = searchFields.find(({ displayOrder }) => displayOrder === selectedSearchField.displayOrder - 1)
			const nextSearchField = searchFields.find(({ displayOrder }) => displayOrder === selectedSearchField.displayOrder + 1)
			if (direction === moveUp) {
				previousSearchField.displayOrder += 1
				selectedSearchField.displayOrder -= 1
			} else {
				selectedSearchField.displayOrder += 1
				nextSearchField.displayOrder -= 1
			}
			this.updateSearchFields(searchFields)
		},
		changeSearchResultsDisplayOrder (index, direction) {
			const fieldId = this.searchResultsFields[index].searchFieldId
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const moveUp = 'moveUp'
			const selectedResultsField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			const previousResultsField = searchFields.find(({ searchResultsDisplayOrder }) => searchResultsDisplayOrder === selectedResultsField.searchResultsDisplayOrder - 1)
			const nextResultsField = searchFields.find(({ searchResultsDisplayOrder }) => searchResultsDisplayOrder === selectedResultsField.searchResultsDisplayOrder + 1)
			if (direction === moveUp) {
				previousResultsField.searchResultsDisplayOrder += 1
				selectedResultsField.searchResultsDisplayOrder -= 1
			} else {
				selectedResultsField.searchResultsDisplayOrder += 1
				nextResultsField.searchResultsDisplayOrder -= 1
			}
			this.updateSearchFields(searchFields)
		},
		addSearchCriteriaFields () {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const startOrder = this.searchableFields.length + 1
			this.selectedSearchCriteriaFields.forEach((fieldId, index) => {
				const addedSearchField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
				addedSearchField.isSearchableBy = true
				addedSearchField.displayOrder = startOrder + index
			})
			this.selectedSearchCriteriaFields = []
			this.searchCriteriaSearchInput = null
			this.searchCriteriaSelectAllChecked = false
			this.updateSearchFields(searchFields)
		},
		addSearchResultFields () {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const startOrder = this.searchResultsFields.length + 1
			this.selectedSearchResultFields.forEach((fieldId, index) => {
				const addedResultField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
				addedResultField.includeInSearchResults = true
				addedResultField.searchResultsDisplayOrder = startOrder + index
			})
			this.selectedSearchResultFields = []
			this.searchResultSearchInput = null
			this.searchResultSelectAllChecked = false
			this.updateSearchFields(searchFields)
			const searchResultFieldsLength = searchFields.filter(({ includeInSearchResults }) => includeInSearchResults).length
			if (searchResultFieldsLength === this.maxSearchResultsFields) {
				showSnackbar('Max limit of search results fields reached')
			}
		},
		addProfileGridFields () {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			this.selectedProfileGridFields.forEach(fieldId => {
				const addedProfileField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
				addedProfileField.showInProfilesTable = true
			})
			this.selectedProfileGridFields = []
			this.updateSearchFields(searchFields)
		},
		deleteSearchField (fieldId) {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const deletedSearchField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			searchFields.forEach((searchField, index) => {
				if (searchField.displayOrder > deletedSearchField.displayOrder) {
					searchFields[index].displayOrder -= 1
				}
			})
			deletedSearchField.isSearchableBy = false
			this.updateSearchFields(searchFields)
		},
		deleteSearchResultField (fieldId) {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const deletedResultField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			searchFields.forEach((resultField, index) => {
				if (resultField.searchResultsDisplayOrder > deletedResultField.searchResultsDisplayOrder) {
					searchFields[index].searchResultsDisplayOrder -= 1
				}
			})
			deletedResultField.includeInSearchResults = false
			this.updateSearchFields(searchFields)
		},
		deleteProfileGridField (fieldId) {
			const searchFields = JSON.parse(JSON.stringify(this.searchFields))
			const deletedProfileField = searchFields.find(({ searchFieldId }) => searchFieldId === fieldId)
			deletedProfileField.showInProfilesTable = false
			this.updateSearchFields(searchFields)
		},
		updateSearchFields (searchFields) {
			const updatedSearchFields = [...searchFields]
			this.updateConfiguration('dataSubjectSearchFieldsList', updatedSearchFields)
		},
		updateConfiguration (key, value) {
			const configuration = {
				...this.configuration,
				[key]: value
			}
			this.$emit('update-configuration', configuration)
		},
		toggleSearchCriteriaSelectAll () {
			if (this.searchCriteriaSelectAllChecked) {
				this.searchCriteriaSelectAllChecked = false
				this.selectedSearchCriteriaFields = []
			} else {
				this.searchCriteriaSelectAllChecked = true
				if (this.searchCriteriaSearchInput) {
					this.selectedSearchCriteriaFields = this.availableSearchCriteriaFields.filter(field => field.text.toLowerCase().includes(this.searchCriteriaSearchInput.toLowerCase()))
						.map(field => field.value)
				} else {
					this.selectedSearchCriteriaFields = this.availableSearchCriteriaFields.map(field => {
						return field.value
					})
				}
			}
		},
		updateSearchCriteriaSelectAllChecked () {
			const filteredFields = this.searchCriteriaSearchInput
				? this.availableSearchCriteriaFields.filter(field => field.text.toLowerCase().includes(this.searchCriteriaSearchInput.toLowerCase()))
				: this.availableSearchCriteriaFields
			this.searchCriteriaSelectAllChecked = this.selectedSearchCriteriaFields.length === filteredFields.length
		},
		toggleSearchResultSelectAll () {
			if (this.searchResultSelectAllChecked) {
				this.searchResultSelectAllChecked = false
				this.selectedSearchResultFields = []
			} else {
				this.searchResultSelectAllChecked = true
				if (this.searchResultSearchInput) {
					this.selectedSearchResultFields = this.availableSearchResultFields.filter(field => field.text.toLowerCase().includes(this.searchResultSearchInput.toLowerCase()))
						.map(field => field.value)
				} else {
					this.selectedSearchResultFields = this.availableSearchResultFields.map(field => {
						return field.value
					})
				}
			}
		},
		updateSearchResultSelectAllChecked () {
			const filteredFields = this.searchResultSearchInput
				? this.availableSearchResultFields.filter(field => field.text.toLowerCase().includes(this.searchResultSearchInput.toLowerCase()))
				: this.availableSearchResultFields
			this.searchResultSelectAllChecked = this.selectedSearchResultFields.length === filteredFields.length
		}
	}
}
</script>
